import { DataTable, DataTablePageEvent } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { InputSwitch } from "primereact/inputswitch";
import { Toast, ToastMessage } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import UserSwipeMachineDialog from "./userSwipeMachineDialog";
import userSwipeMachineService from "../../services/SwipeMachine-UserAccess/UserSwipeMachineService";
import "./UserSwipeMachineAccess.scss";

export default function UserSwipeMachineAccess() {
  const toast = useRef<Toast>(null);

  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState(10);
  const [allData, setAllData] = useState<any[]>([]);
  const [search, setSearch] = useState("");
  const [dialogVisible, setDialogVisible] = useState(false);
  const [editData, setEditData] = useState<any>(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await userSwipeMachineService.getUserSwipeMachineMapping();

      const list = res && Array.isArray(res.data)
        ? res.data
        : Array.isArray(res)
          ? res
          : [];

      setAllData(list);   // 🔹 master copy
      setData(list);


    } catch (err) {
      console.error(err);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to load mappings"
      });
    } finally {
      setLoading(false);
    }
  };

  const statusTemplate = (row: any) => (
    <InputSwitch
      checked={!row.isDelete}

      onChange={async (e) => {
        const isDelete = e.value;
        const newisDelete = !isDelete;

        const payload = {
          assignedId: row.id,
          swipeMachineId: row.swipeMachineId,
          isDelete: newisDelete,
        };

        const success = await userSwipeMachineService.updateUserSwipeMachineMapping(payload);

        if (success) {
          toast.current?.show({
            severity: "success",
            summary: "Updated",
            detail: newisDelete ? "Access disabled" : "Access enabled"
          });
          loadData();
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Failed to update status"
          });
        }
      }}
    />
  );

  const handleSearchChange = (value: string) => {
    setSearch(value);

    const keyword = value.trim().toLowerCase();

    if (!keyword) {
      setData(allData); // reset when empty
      return;
    }

    const filtered = allData.filter((row) =>
      row.userName?.toLowerCase().includes(keyword) ||
      row.contactNumber?.toLowerCase().includes(keyword) ||
      row.serialNumber?.toLowerCase().includes(keyword) ||
      row.role?.toLowerCase().includes(keyword)
    );

    setData(filtered);
  };

  return (
    <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
      <Toast ref={toast} />

      <div className="card p-4 w-full">
        {/* 2️⃣ LIGHT GREEN INNER SECTION */}
        <div className="card p-4 w-full" style={{
          backgroundColor: '#e8f5e9',
          borderRadius: '12px'
        }}>

          {/* 3️⃣ GRADIENT HEADER */}
          <div className="swipe-header-gradient">
            <div className="swipe-header-icon">
              <i className="pi pi-lock" />
            </div>

            <div className="swipe-header-text">
              <h5>User Swipe Machine Access</h5>
              <p>Manage and track user access to swipe machines</p>
            </div>
          </div>

          <div className="flex align-items-center gap-2 mb-3">
            <i className="pi pi-filter" style={{ color: 'rgb(76, 175, 80)', fontSize: '1.1rem' }}></i>
            <span style={{ fontWeight: '600', color: '#2d3748', fontSize: '0.95rem' }}>Filter Access</span>
          </div>

          {/* Filter Section */}
          <div className="flex justify-content-between align-items-center gap-3">
            <div className="flex align-items-center gap-2" style={{ flex: 1, maxWidth: '400px' }}>
              <span className="p-input-icon-left w-full">
                <i className="pi pi-search" />
                <InputText
                  type="search"
                  value={search}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  placeholder="Search by User or Swipe Machine"
                  className="w-full"
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    border: '1px solid #d1d5db'
                  }}
                />

              </span>
            </div>

            <div className="flex align-items-center gap-2">
              <Button
                label="Add"
                icon="pi pi-plus"
                onClick={() => {
                  setEditData(null);
                  setDialogVisible(true);
                }}
                className="p-button-success"
              />
            </div>
          </div>
        </div>

        {/* 5️⃣ WHITE DATATABLE CARD */}
        <div >
          <DataTable
            value={data}
            paginator
            rows={rows}
            rowsPerPageOptions={[5, 10, 20, 50]}
            loading={loading}
            stripedRows
            rowHover
            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
            className="myorders-datatable"
            style={{
              borderRadius: '8px',
              overflow: 'hidden',
              background: 'white',
              border: '1px solid rgb(224, 224, 224)'
            }}
          >

            <Column
              header="USER"
              body={(r) => (
                <div>
                  <div className="font-semibold">{r.userName}</div>
                  <div className="text-500 text-sm">{r.role}</div>
                </div>
              )}
            />
            <Column field="contactNumber" header="CONTACT #" />
            <Column field="serialNumber" header="SWIPE MACHINE" />
            <Column field="posName" header="POS" />
            <Column field="assiginedBy" header="ASSIGNED BY" />
            <Column field="assignedDate" header="ASSIGNED DATE" body={(r) => r.assignedDate ? new Date(r.assignedDate).toLocaleDateString() : ''} />
            <Column header="STATUS" body={statusTemplate} style={{ textAlign: "center" }} />
            <Column
              header="ACTION"
              body={(r) => (
                <Button
                  icon="pi pi-pencil"
                  className="p-button-rounded p-button-success"
                  onClick={() => {
                    setEditData(r);
                    setDialogVisible(true);
                  }}
                />
              )}
              style={{ textAlign: "center" }}
            />
          </DataTable>
        </div>

        {/* </div> */}
      </div>

      <UserSwipeMachineDialog
        visible={dialogVisible}
        editData={editData}
        onHide={() => setDialogVisible(false)}
        onSaved={loadData}
        showToast={(msg: ToastMessage) =>
          toast.current?.show(msg)
        }
      />
    </div>
  );
}
